import { call, put, select, takeLatest } from 'redux-saga/effects'

import { IHateoasLink } from '@store'
import { selectAuthToken } from '@store/auth/selectors'
import { fetchCampaignSuccess, selectCampaignLink } from '@store/campaigns'
import { detachNotes, detachNotesFailure, detachNotesSuccess } from '@store/discoveryRuns/actions'
import { DETACH_NOTES_REL, extractVerbatimErrorMessage } from '@store/discoveryRuns/api'
import { toast } from '@tribegroup'
import { networkRequest } from '@utils/networkRequest'

// BRAND-9582 item 13 (FINAL fix): mirrors attachNotesSaga exactly — see
// detachTranscriptSaga's doc for why this uses networkRequest with no body
// instead of multipartRequest, and why no isAlreadyAttachedError handling is
// needed (detach is idempotent).
export function* detachNotesSaga(action: ReturnType<typeof detachNotes>) {
  const { campaignId } = action.payload
  try {
    const token: string = yield select(selectAuthToken)
    // detach_notes is a rel on the BRIEF's own top-level `links` (not nested
    // inside the `sourcing` block).
    const link: IHateoasLink | undefined = yield select(
      selectCampaignLink,
      campaignId,
      DETACH_NOTES_REL,
    )
    if (!link) {
      yield put(detachNotesFailure("Notes can't be removed right now."))
      yield call(toast, "Notes can't be removed right now.")
      return
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response: any = yield call(networkRequest, link.method, link.href, undefined, token)
    yield put(fetchCampaignSuccess(response))
    yield put(detachNotesSuccess())
  } catch (e: any) {
    const message = extractVerbatimErrorMessage(e)
    yield put(detachNotesFailure(message))
    yield call(toast, message)
  }
}

export default function* watchDetachNotes() {
  yield takeLatest(detachNotes.type, detachNotesSaga)
}
